/** Единые URL входа: касса = PIN, админка = /login?admin=1 */

export const CASHIER_LOGIN_PATH = '/cashier/login';
export const ADMIN_LOGIN_QUERY = 'admin=1';
export const COMPANY_CODE_STORAGE_KEY = 'pos.companyLoginCode';

export function isDesktopCashier() {
  if (typeof window === 'undefined') return false;
  if (window.desktopCashier?.isDesktop) return true;
  // Запасной признак: preload мог не успеть или старая сборка без bridge
  return typeof navigator !== 'undefined' && /Electron/i.test(navigator.userAgent);
}

/** Код компании на PIN-экране: скрываем только если десктоп реально отдаёт код из настроек. */
export function shouldShowCashierCompanyCodeField() {
  if (typeof window === 'undefined') return true;
  if (window.desktopCashier?.isDesktop && typeof window.desktopCashier.getCompanyLoginCode === 'function') {
    return false;
  }
  return true;
}

export function isAuthPage(pathname = '') {
  const p = pathname || (typeof window !== 'undefined' ? window.location.pathname : '');
  return (
    p.startsWith(CASHIER_LOGIN_PATH)
    || p.startsWith('/login')
    || p.startsWith('/auth/accept')
  );
}

export function adminLoginPath() {
  return `/login?${ADMIN_LOGIN_QUERY}`;
}

export function normalizeCompanyLoginCode(code) {
  const digits = String(code || '').trim().replace(/\D/g, '');
  if (!digits) return '';
  const n = parseInt(digits, 10);
  if (!Number.isFinite(n) || n < 10000 || n > 99999) return '';
  return String(n).padStart(5, '0');
}

/** Только цифры, до 5 символов — для поля ввода без сброса при наборе. */
export function sanitizeCompanyLoginCodeInput(raw) {
  return String(raw || '').replace(/\D/g, '').slice(0, 5);
}

export function persistCompanyLoginCode(code) {
  const normalized = normalizeCompanyLoginCode(code);
  try {
    if (normalized) {
      localStorage.setItem(COMPANY_CODE_STORAGE_KEY, normalized);
    } else {
      localStorage.removeItem(COMPANY_CODE_STORAGE_KEY);
    }
  } catch {
    /* ignore */
  }
  return normalized;
}

export async function resolveCashierCompanyCode(searchParams) {
  if (isDesktopCashier() && window.desktopCashier?.getCompanyLoginCode) {
    try {
      const fromDesktop = await window.desktopCashier.getCompanyLoginCode();
      const code = persistCompanyLoginCode(fromDesktop);
      if (code) return code;
    } catch {
      /* ignore */
    }
  }

  const fromUrl = searchParams?.get?.('companyLoginCode');
  if (fromUrl) {
    return persistCompanyLoginCode(fromUrl);
  }

  try {
    const stored = localStorage.getItem(COMPANY_CODE_STORAGE_KEY);
    if (stored) return normalizeCompanyLoginCode(stored);
  } catch {
    /* ignore */
  }
  return '';
}

/** Pharmacy SPA login — PIN keypad (desktop + web). Office handoff: /auth/accept. */
export const PHARMACY_LOGIN_PATH = '/login';

export function cashierLoginPath() {
  // This package is pharmacy-frontend — always stay on pharmacy origin login.
  if (isDesktopCashier()) return PHARMACY_LOGIN_PATH;
  return PHARMACY_LOGIN_PATH;
}

/** Куда отправлять при logout / 401 в контексте кассы или десктопа. */
export function defaultLoginPath() {
  return PHARMACY_LOGIN_PATH;
}

export function redirectToLogin() {
  if (typeof window === 'undefined') return;
  const target = defaultLoginPath();
  if (window.location.pathname + window.location.search === target) return;
  window.location.href = target;
}

export function cashierSessionMatchesCompany(user, companyCode) {
  if (!user || !['CASHIER', 'WAITER'].includes(user.role)) return true;
  const expected = normalizeCompanyLoginCode(companyCode);
  if (!expected) return true;
  const sessionCode = normalizeCompanyLoginCode(user.companyLoginCode);
  // Нет кода в профиле — не выкидываем (свежий PIN-логин / старый JWT без поля).
  if (!sessionCode) return true;
  return sessionCode === expected;
}
